import React, { useState } from 'react';

const FAQComponent = () => {
  const [visibleAnswer, setVisibleAnswer] = useState(null);

  const faqs = [
    {
      question: 'How do I register new consultants under me?',
      answer: 'Copy your invitation link that looks like this on your dashbaord https://portal-sanieldanproperties.onrender.com/4649959/signup and send to the everybody you want to register.'
    },
    {
      question: 'How do I see my downlines?',
      answer: 'You log in to your portal and then click on the menu button on left-hand side of the page. Then click on "Team mates" and that will bring all the generations, that is, Direct and Indirect.'
    },
    {
      question: 'How do I edit my details?',
      answer: "Click on 'Profile' from the menu list and you can edit your personal details there."
    },
    {
      question: 'How do I register a client?',
      answer: 'Go to your Clients page where you will see 2 different tabs - one to view your existing clients and another to register new clients. Click on the "Register New Client" tab and fill in the required details to register your client.'
    },
    {
      question: 'How do I send out proposals?',
      answer: 'On your dashboard, you will see the list of available properties. Click on the "Share" link for the property you want to propose. A modal will pop up where you can input the client\'s email and name to send the proposal.'
    },
    {
      question: 'How do I close a deal for outright purchase?',
      answer: 'When you have a client ready to purchase a property: 1) Go to your dashboard 2) Click the "Upload Payment Receipt" button 3) In the modal that appears, select the client from the first section 4) Fill in the payment details in the second section 5) Submit the form. Once payment is verified, you will receive your commission.'
    },
    {
      question: 'How do I close a deal for installment plan?',
      answer: 'The process is similar to outright purchase: 1) Go to your dashboard 2) Click "Upload Payment Receipt" 3) Select the client 4) Fill in the installment payment details (make sure to specify it\'s an installment) 5) Submit. For subsequent installments, repeat the process until full payment is completed. Commission may be paid proportionally or according to company policy.'
    }
  ];

  const toggleAnswerVisibility = (index) => {
    setVisibleAnswer(visibleAnswer === index ? null : index);
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4 text-left">Frequently Asked Questions</h1>
      {faqs.map((faq, index) => (
        <div key={index} className="mb-4">
          <button
            onClick={() => toggleAnswerVisibility(index)}
            className="text-left w-full text-lg font-semibold text-blue-500 hover:underline"
          >
            {index + 1}. {faq.question}
          </button>
          {visibleAnswer === index && (
            <p className="mt-2 text-gray-700 text-left">{faq.answer}</p>
          )}
        </div>
      ))}
    </div>
  );
};

export default FAQComponent;